import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'antd';
import { useIntl } from 'react-intl';
import DrawerModal from '../../shared/DrawerModal';
import SelectorLayout from '../../shared/SelectorLayout';
import styles from './UserManualApprovalModal.styles';
import { getIsVisibleModal, closeModal } from '../../../redux/store/ui/common';
import {
  selectSelectedUser,
  updateUser,
} from '../../../redux/store/userData/users';

const MANUAL_APPROVAL_OPTIONS = ['open', 'verified', 'failed'];

const UserManualApprovalModal: React.FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const selectedUser = useSelector(selectSelectedUser);
  const visible = useSelector(getIsVisibleModal('UserManualApprovalModal'));
  const currentStatus = selectedUser?.manualApproval;
  const [nextStatus, setNextStatus] = useState(currentStatus);

  const options = MANUAL_APPROVAL_OPTIONS.map((status) => ({
    label: intl.formatMessage({ id: `fleetadmin.status.${status}` }),
    value: status,
  }));

  const handleCancel = () => {
    dispatch(closeModal('UserManualApprovalModal'));
  };

  const handleOnSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(updateUser(selectedUser.id, { manualApproval: nextStatus }));
    handleCancel();
  };

  useEffect(() => {
    if (visible) {
      setNextStatus(currentStatus);
    }
  }, [visible, currentStatus]);

  return (
    <>
      <DrawerModal visible={visible} onClose={handleCancel}>
        <div
          data-testid="UserManualApprovalModal"
          className="user-manual-approval-modal"
        >
          <div className="status-selector-wrapper">
            <p className="label">
              {intl.formatMessage({
                id: `fleetadmin.users.status.title.manuallyApproved`,
                defaultMessage: 'Manual Approval Status',
              })}
            </p>
            <SelectorLayout
              testid="UserManualApproval"
              keyPrefix="manual-approval"
              placeholder={intl.formatMessage({
                id: 'fleetadmin.user.status.placeholder',
              })}
              options={options}
              value={nextStatus}
              onSelect={setNextStatus}
            />
          </div>
          <Button
            data-testid="UserManualApprovalModal-submitBtn"
            className="submit-button"
            onClick={handleOnSubmit}
            disabled={!nextStatus || nextStatus === currentStatus}
          >
            {intl.formatMessage({ id: `submit` })}
          </Button>
          <Button className="cancel-button" onClick={handleCancel}>
            {intl.formatMessage({ id: `cancel` })}
          </Button>
        </div>
      </DrawerModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default UserManualApprovalModal;
